import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

// Component
import Color from "../../assets/color";

//UI Component
import Link from "../../components/Link";
import StarRatings from "react-star-ratings";

// Styles
import { RestaurantCardInfoStyled } from "./style";

class RestaurantCardInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  _img = m => {
    let img = "";
    let _defaultImg = () => {
      img = require("../../assets/img/default-img-restaurant.png");
    };
    if (m.length !== 0) {
      m.forEach((d, i) => {
        if (d.type === "profile") {
          img = m[i].path;
        } else {
          img = m[0].path;
        }
        return img;
      });
    } else {
      _defaultImg();
    }

    return img;
  };

  render() {
    const { data, horizontal } = this.props;
    return (
      <RestaurantCardInfoStyled>
        {horizontal !== undefined ? (
          <Link
            className="restaurant-card-link"
            target="_blank"
            to={`/restaurant/?restaurant=${data.restaurant_id}`}
          >
            <div className="restaurant-card-info">
              <div className="d-flex align-items-center">
                <div className="text-center">
                  <div className="image">
                    <div
                      className="background"
                      style={{
                        backgroundImage: `url(${this._img(data.Media)})`
                      }}
                    />
                  </div>
                </div>
                <div className="info">
                  <h3 className="">{data.restaurant_name}</h3>
                  <div className="restaurant-setting">
                    {data.RestaurantSetting.delivery !== undefined &&
                      data.RestaurantSetting.delivery && (
                        <p>
                          Delivery<span>/</span>
                        </p>
                      )}
                    {data.RestaurantSetting.dine_in !== undefined &&
                      data.RestaurantSetting.dine_in && (
                        <p>
                          Dine-in<span>/</span>{" "}
                        </p>
                      )}
                    {data.RestaurantSetting.pick_up !== undefined &&
                      data.RestaurantSetting.pick_up && (
                        <p>
                          Pick-up<span>/</span>
                        </p>
                      )}

                    {data.RestaurantSetting.table_reserve !== undefined &&
                      data.RestaurantSetting.table_reserve && (
                        <p>
                          Table-reserve<span>/</span>
                        </p>
                      )}
                  </div>
                  <div className="d-flex review align-items-center">
                    <StarRatings
                      rating={parseFloat(data.avg_rating)}
                      starRatedColor={Color.primary}
                      numberOfStars={5}
                      name="rating"
                      starDimension="16px"
                      starSpacing="2px"
                    />
                    <p className="pl-2">{data.total_vote} reviews</p>
                  </div>
                  <p>{data.restaurant_state}</p>
                  {data.ambience !== undefined && data.ambience.length !== 0 && (
                    <div className="ambience">
                      {data.ambience.map((d, i) => {
                        return (
                          <p className="d-inline-block" key={i}>
                            {d}
                            <span>&#183;</span>
                          </p>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Link>
        ) : (
          <Link
            className="restaurant-card-link"
            target="_blank"
            to={`/restaurant/?restaurant=${data.restaurant_id}`}
          >
            <div className="restaurant-card-info-vertical">
              <div className="image">
                <div
                  className="background"
                  style={{
                    backgroundImage: `url(${this._img(data.Media)})`
                  }}
                />
              </div>
              <div className="info">
                <h3 className="">{data.restaurant_name}</h3>
                <div className="restaurant-setting">
                  {data.RestaurantSetting.delivery !== undefined &&
                    data.RestaurantSetting.delivery && (
                      <p>
                        Delivery<span>/</span>
                      </p>
                    )}
                  {data.RestaurantSetting.dine_in !== undefined &&
                    data.RestaurantSetting.dine_in && (
                      <p>
                        Dine-in<span>/</span>{" "}
                      </p>
                    )}
                  {data.RestaurantSetting.pick_up !== undefined &&
                    data.RestaurantSetting.pick_up && (
                      <p>
                        Pick-up<span>/</span>
                      </p>
                    )}

                  {data.RestaurantSetting.table_reserve !== undefined &&
                    data.RestaurantSetting.table_reserve && (
                      <p>
                        Table-reserve<span>/</span>
                      </p>
                    )}
                </div>
                <div className="d-flex review align-items-center">
                  <StarRatings
                    rating={parseFloat(data.avg_rating)}
                    starRatedColor={Color.primary}
                    numberOfStars={5}
                    name="rating"
                    starDimension="16px"
                    starSpacing="2px"
                  />
                  <p className="pl-2">{data.total_vote} reviews</p>
                </div>
                <p>{data.restaurant_state}</p>
                {data.ambience !== undefined && data.ambience.length !== 0 && (
                  <div className="ambience">
                    {data.ambience.length >= 10 &&
                      data.ambience.slice(0, 9).map((d, i) => {
                        return (
                          <p className="" key={i}>
                            <span>{d}</span>
                            <span>&#183;</span>
                          </p>
                        );
                      })}
                    {data.ambience.length >= 10 && <p className="">...</p>}
                    {data.ambience.length < 10 &&
                      data.ambience.map((d, i) => {
                        return (
                          <p className="" key={i}>
                            <span>{d}</span>
                            <span>&#183;</span>
                          </p>
                        );
                      })}
                  </div>
                )}
              </div>
            </div>
          </Link>
        )}
      </RestaurantCardInfoStyled>
    );
  }
}

RestaurantCardInfo.propTypes = {
  data: PropTypes.object.isRequired
};

export default withRouter(RestaurantCardInfo);
